import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface CreateChronologyFromThreadParameters {
  caseId: string;
  threadId: string;
}

export interface CreateChronologyFromThreadResponse {
  caseId: string;
  chronologyId: string;
  chronologyTitle: string;
  isNew: boolean;
  isProcessed: boolean;
}

export const useCreateChronologyFromThread = () => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation({
    mutationFn: async ({ caseId, threadId }: CreateChronologyFromThreadParameters) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: {
          threadId,
        },
      });
      const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/chronology/from-thread`, fetchConfig);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json() as Promise<CreateChronologyFromThreadResponse>;
    },
    onSuccess: () => {
      toast.success('Chronology successfully created');
    },
    onError: () => {
      toast.error('Failed to create chronology');
    },
  });
};
